import { useEffect, useState } from 'react';

const useToast = (
  time: number = 2000,
  onHide: Function = () => {}
): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (showToast === true) {
      timeout = setTimeout(() => {
        setShowToast(false);
        onHide();
      }, time);
    }

    return () => clearTimeout(timeout);
  }, [showToast, time, onHide]);

  return [showToast, setShowToast];
};

export default useToast;
